import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { EVoyageMissionType } from '../missions/voyageMissionData'
import { voyageGameMode_game_director } from '../voyageGameMode_game_director-sidecar'
import { voyageGameMode_game_hyperspace } from '../voyageGameMode_game_hyperspace-sidecar'
import { voyageGameStatus } from '../voyageGameStatus-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'

export interface IMessageJump {
  command: EJumpCommand
  isStarbase: boolean
  locationName: string
  missionType: EVoyageMissionType
}

export enum EJumpCommand {
  Request = 1,
  Engage = 2,
}

export const voyageMessageId = EVoyageMessage.Jump

export function write(m: IMessageWriter, d: IMessageJump) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write8(m, d.command)
  messageWriter.writeBool(m, d.isStarbase)
  messageWriter.writeString(m, d.locationName)
  messageWriter.write8(m, d.missionType)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageJump = {
    command: messageWriter.read8(m),
    isStarbase: messageWriter.readBool(m),
    locationName: messageWriter.readString(m),
    missionType: messageWriter.read8(m),
  }

  return d
}

export function test() {
  let ex: IMessageJump = {
    command: EJumpCommand.Engage,
    isStarbase: true,
    locationName: 'somewhere',
    missionType: EVoyageMissionType.SurveyAnomaly,
  }
  messageWriter.test('jump', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  // voyageCrew.networkHurt(msg)

  if (msg.command === EJumpCommand.Request) {
    if (voyageWebsockets.getIsHost()) {
      let status = voyageGameStatus.get()
      if (status.jumpCharge >= 95) {
        sendMessageAndImmediatelyExecute({
          command: EJumpCommand.Engage,
          isStarbase: msg.isStarbase,
          locationName: msg.locationName,
          missionType: msg.missionType,
        })
      }
    }
  }
  if (msg.command === EJumpCommand.Engage) {
    let status = voyageGameStatus.get()
    status.addJumpCharge += -100
    status.isAtStarbase = msg.isStarbase
    status.locationName = msg.locationName
    voyageGameStatus.setMission(msg.missionType)
    voyageGameMode_game_hyperspace.signalHyperspace()
    if (voyageWebsockets.getIsHost()) {
      voyageGameMode_game_director.signalAction()
    }
  }
}

export function sendMessageAndImmediatelyExecute(msg: IMessageJump) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}

export function sendMessageRequest(msg: IMessageJump) {
  websockets._sendMessageRequest(write, msg)
}
